import React from 'react';
import { FieldController, NameValidator, TextField, DescriptionValidator, TextArea, Anchor, Button } from '@keplerco/core';
import { useState } from 'react';
import { FieldValues, useForm } from 'react-hook-form';
import { SkeletonLoader } from '../../../../components/general/loading-state/loaders/skeleton-loader/skeleton-loader';
import { useAppActions, useAppState } from '../../../../overmind';
import { CompanySkillListItemResponse } from '../../../../models/overmind/company-entity';

export function SaveSkillWidget({ selectedSkill, onCancel, onSave }: { selectedSkill: CompanySkillListItemResponse | undefined; onCancel: () => void; onSave: () => void }): JSX.Element {
  const actions = useAppActions();
  const { companyVariables } = useAppState();

  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { control, handleSubmit } = useForm({ mode: 'onBlur', reValidateMode: 'onBlur', defaultValues: { name: selectedSkill?.name, description: selectedSkill?.description } as FieldValues });

  if (isLoading) return <SkeletonLoader height={'250px'} />;

  return (
    <form
      id="skillDetails"
      className="panelForm"
      onSubmit={handleSubmit(async fieldValues => {
        setIsLoading(true);

        const request = {
          companySlug: companyVariables.slug!,
          name: fieldValues.name,
          description: fieldValues.description,
        };
        const response = selectedSkill ? await actions.updateCompanySkill({ ...request, entitySlug: selectedSkill.slug! }) : await actions.createCompanySkill(request);
        if (!response.error) onSave();

        setIsLoading(false);
      })}
    >
      <div>
        <div className="card">
          <FieldController
            control={control}
            name="name"
            rules={new NameValidator()}
            render={({ field, fieldState }) => (
              <TextField
                {...field}
                type="text"
                label="Skill name"
                responsive
                validation={{
                  dirty: fieldState.isDirty || !!fieldState.error,
                  invalid: !!fieldState.error,
                  message: fieldState.error?.message ?? 'Enter a name',
                }}
              />
            )}
          />

          <FieldController
            control={control}
            name="description"
            rules={new DescriptionValidator()}
            render={({ field, fieldState }) => (
              <TextArea
                {...field}
                label="Skill description"
                responsive
                validation={{
                  dirty: fieldState.isDirty || !!fieldState.error,
                  invalid: fieldState.invalid,
                  message: fieldState.error?.message ?? 'Enter a description',
                }}
              />
            )}
          />
        </div>
      </div>

      <footer className="panelFooter">
        <Anchor onClick={onCancel}>Cancel</Anchor>

        <Button type="button">Save</Button>
      </footer>
    </form>
  );
}
